<template>
  <div class="index">
    <p>pat [@] s3c [.] ninja</p>
    <p>0xefaaa45014fb8f16baef0c196c97eeac84bc64d7</p>
    <br />
    <pre>
-----BEGIN PGP PUBLIC KEY BLOCK-----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=i0A/
-----END PGP PUBLIC KEY BLOCK-----
    </pre>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
